import { forwardRef } from 'react';

import { SkeletonProps } from './Skeleton.types';
import { StyledSkeleton } from './Skeleton.styled';

export const Skeleton = forwardRef<HTMLSpanElement, SkeletonProps>(
  ({ mode, className, ...props }: SkeletonProps, ref) => {
    const skeletonClassName = [mode === 'dark' ? 'dark' : 'light', className].filter(Boolean).join(' ');

    return <StyledSkeleton {...props} animation="wave" className={skeletonClassName} ref={ref} />;
  },
);

Skeleton.displayName = 'Skeleton';
